import React, { useEffect, useState } from 'react';

import './styles.css';

import close from '../../../assets/images/close.svg';
import statistics from '../../../assets/images/statistics.svg';
import shiftsImg from '../../../assets/images/shifts.svg';
import moment from "moment";
import 'moment/locale/pt-br';
import api from '../../../services/api';

export const ModalShiftsVisited = ({ handleClose, title, id, type, totalPlantoesVisitados, filter }) => {
  const [plantoes, setPlantoes] = useState([]);

  useEffect(() => {
    getPlantoes();
  }, []);

  const getPlantoes = async () => {
    const { data } = await api.get(`${type}/${id}/plantoes`, {
      params: filter
    });
    setPlantoes(data.plantoes);
  }


  return (
    <div className="dash-modal">
      <div className="dash-modal-content lg">
        <button className="btn-close" onClick={() => handleClose()}><img src={close} /></button>
        <div className="dash-modal-header header-modal-pages">
          <div>
            <img src={statistics} />
            <h1>Estatísticas</h1>
          </div>
          <div className="data-about">
            <img src={shiftsImg} />
            <h1>{totalPlantoesVisitados}</h1>
            <p>{title}</p>
          </div>
        </div>
        <div className="dash-modal-body">
          <div className="box-card h-full">
            <div className="box-card-noPadding box-table-shifts">
              <table className="table-dash">
                <thead>
                  <tr className="light-blue">
                    <th>Dia</th>
                    <th>Plantão</th>
                    {type !== "corretores" &&
                      <th>Corretores do time</th>
                    }
                  </tr>
                </thead>
                <tbody>
                  {plantoes.map((plantao, key) => (
                    <tr key={key}>
                      <td>{moment(plantao.data).format("DD/MM/YYYY")}</td>
                      <td>{plantao.plantao.imovel_nome}</td>
                      {type !== "corretores" &&
                        <td>{plantao.corretores}</td>
                      }
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="dash-modal-footer">

        </div>
      </div>
    </div>
  );

}

export default ModalShiftsVisited;